var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

const React = require('react');
const Icon = require('@infotech/uikit-icon').default;

function Svg(props) {
  const svgProps = Object.assign({}, props);
  const title = props.title;
  delete props.title;

  /* <svg {...svgProps} ><title>{title}<title>...</svg> */
  return React.createElement(
    'svg',
    _extends({ width: '24', height: '24', viewBox: '0 0 24 24', focusable: 'false' }, svgProps, { 'aria-labelledby': 'title' }),
    React.createElement(
      'title',
      { id: 'title' },
      title
    ),
    React.createElement('path', { d: 'M9 18A9 9 0 119 0a9 9 0 010 18zm0-2A7 7 0 109 2a7 7 0 000 14zm0-6a1 1 0 01-1-1V5a1 1 0 112 0v3h3a1 1 0 010 2H9z', fillRule: 'evenodd', role: 'presentation' })
  );
}

module.exports = function timePopap(props) {
  return React.createElement(Icon, _extends({ glyph: Svg }, props));
};